import { useAlertStore } from '../../store/alertStore'
import { AU_STATES, AU_BBOX } from '../../constants/auStates'

export default function RegionFilter() {
  const { filters, setFilters, fitBounds } = useAlertStore()
  const selectedState = filters.region

  const handleStateClick = (code: string, bbox: [number, number, number, number]) => {
    if (selectedState === code) {
      setFilters({ region: null })
      fitBounds?.(AU_BBOX)
    } else {
      setFilters({ region: code })
      fitBounds?.(bbox)
    }
  }

  return (
    <div className="px-3 py-2 space-y-2">
      <div className="flex items-center gap-2">
        <input
          type="search"
          placeholder="Search alerts…"
          value={filters.search}
          onChange={(e) => setFilters({ search: e.target.value })}
          className="flex-1 bg-gray-100 border border-gray-300 text-gray-800 placeholder-gray-500 focus:border-gray-400 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 dark:focus:border-gray-500 rounded-md px-3 py-1.5 text-sm focus:outline-none transition-colors"
        />
        <label className="flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400 shrink-0 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={filters.active_only}
            onChange={(e) => setFilters({ active_only: e.target.checked })}
            className="accent-blue-500 w-3.5 h-3.5"
          />
          Active only
        </label>
      </div>

      <div className="flex flex-wrap gap-1">
        {AU_STATES.map(({ code, bbox }) => (
          <button
            key={code}
            type="button"
            onClick={() => handleStateClick(code, bbox)}
            className={`px-2 py-0.5 rounded text-xs font-medium border transition-all ${
              selectedState === code
                ? 'bg-blue-600 border-blue-500 text-white'
                : 'bg-gray-100 border-gray-300 text-gray-500 hover:border-gray-400 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:border-gray-500 dark:hover:text-gray-200'
            }`}
          >
            {code}
          </button>
        ))}
      </div>
    </div>
  )
}
